import type { AvtalegiroAgreementRequest } from '../../../../generated-types';
import { createAvtaleGiroAgreement } from '../../../../services/avtaleGiroService';
import { AvtaleGiroState } from './state';

export default () => (state: AvtaleGiroState) => {
    const request: AvtalegiroAgreementRequest = {
        fromAccountNumber: state.fromAccount!,
        toAccount: state.toAccount!.accountNumber,
        limits: {
            transaction: state.transactionLimit,
            monthly: state.monthlyLimit,
        },
        kid: state.kid!,
        notification: state.notification,
        ownText: state.note,
    };

    return createAvtaleGiroAgreement(request);
};
